export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14719.c4596fee.jpg";